import { Pipe, PipeTransform } from '@angular/core';
import { OPERATION_REQUEST_STATUS, OPERATION_REQUEST_STATUS_BG, OPERATION_REQUEST_STATUS_COLOR } from 'src/app/core/constants/operation-request-status.enum';
import { REQUEST_STATUS } from 'src/app/core/constants/request-status.enum';
import { TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'getOperationStatus'
})
export class GetOperationStatusPipe implements PipeTransform {
    public constructor(private translateService: TranslateService) {}
    public transform(requestStatus: string): { txt: string; color: string; bg: string } {
        if (requestStatus) {
            const status = Object.keys(REQUEST_STATUS).find(key => key.includes('OPERATION') && REQUEST_STATUS[key] == requestStatus);
            return {
                txt: this.translateService.instant(OPERATION_REQUEST_STATUS[status]),
                color: OPERATION_REQUEST_STATUS_COLOR[status],
                bg: OPERATION_REQUEST_STATUS_BG[status]
            };
        }
        return {
            txt: 'N/A',
            color: 'gray',
            bg: 'black'
        };
    }
}
